import React, { Component } from 'react'
import moment from 'moment'

import CommonTree from '../models/commonTree'
import PageWrapper from '../models/page.model'
import Table from '../table/table'
import MultipleLevelCascader from '../multipleLevelCascader/index'

import {Modal,Button,Form,Input,Row,Col} from "antd"


import { FormComponentProps } from "antd/lib/form";



// model
import QueryResourceParams from './models/queryResourceParams'
import ResourceItem from './models/resourceItem'
// service
import UploadService from './service'
// style
import './style.less'
// util
import {ResourceUtil} from './file.type'

interface iProps extends FormComponentProps{
    onCancel: () => void; // 点击关闭弹窗的回调
    visible: boolean; // 弹窗的状态
    resourceUrl?: string,// 获取资源列表，可以不传(默认是：/leco/ecology/api/v1/teacher/resource/list)
    selectFile: (resourceItem: ResourceItem[]) => void, // 每次选择资源之后的回调，返回值是当前选中的所有资源
    fileType: string, // 资源类型（VIDEO-视频，AUDIO-音频，DOCUMENT-文档）
    maxSize?: number //资源文件的最大限制，单位B
}
interface iState {
    loading: boolean,
    page: PageWrapper<ResourceItem>,
    videoAudioColumns: any[],
    documentColumns: any[],
    resourceCategorylist: CommonTree[],
    selectedResource: ResourceItem[]
}
class SelectFromStoreModal extends Component<iProps, iState> {
    private uploadService: UploadService = new UploadService()
    state: iState 
    = {
        loading: false,
        page: new PageWrapper<ResourceItem>(),
        videoAudioColumns: [
            {
                title: `${this.props.fileType === 'VIDEO' ? '视频': (this.props.fileType === 'AUDIO' ? '音频' : (this.props.fileType === 'DOCUMENT' ? '文档' : '资源'))}名称`,
                dataIndex: "title",
                key: "title",
                width: '40%',
                render : (text, record:ResourceItem) => {
                    return <div className={`uploadItem_name portal-${record.resourceType}`}>
                            {record.title}
                        </div>
                }
            },
            {
                title: `时长`,
                dataIndex: "duration",
                key: "duration",
                width: '25%',
                render : (text, record:ResourceItem) => {
                    return <div>
                        {ResourceUtil.getFileDuration(record.duration)}
                    </div>
                }
            },
            {
                title: `上传时间`,
                dataIndex: "createTime",
                key: "createTime",
                width: '35%',
                render : (text, record:ResourceItem) => {
                    return <div>
                        {moment(new Date(record.createTime)).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                }
            }
        ],
        documentColumns: [
            {
                title: `${this.props.fileType === 'VIDEO' ? '视频': (this.props.fileType === 'AUDIO' ? '音频' : (this.props.fileType === 'DOCUMENT' ? '文档' : '资源'))}名称`,
                dataIndex: "title",
                key: "title",
                width: '40%',
                render : (text, record:ResourceItem) => {
                    return <div className={`uploadItem_name ${record.resourceType ==='DOCUMENT' ? `portal-DOCUMENT ${record.suffix?.split('.')[1]}`: `portal-${record.resourceType}`}`}>
                        {record.title}
                    </div>
                }
            },
            {
                title: `文件大小`,
                dataIndex: "duration",
                key: "duration",
                width: '25%',
                render : (text, record:ResourceItem) => {
                    return <div>
                        {ResourceUtil.getFileSize(record.size)}
                    </div>
                }
            },
            {
                title: `上传时间`,
                dataIndex: "createTime",
                key: "createTime",
                width: '35%',
                render : (text, record:ResourceItem) => {
                    return <div>
                        {moment(new Date(record.createTime)).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                }
            }
        ],
        resourceCategorylist: [],
        selectedResource: []
    }
    formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    };
    // 获取资源分类列表
    getResourceCategoryList = async () => {
        let resourceCategorylist = await this.uploadService.getResourceCategoryList() || []
        this.setState({resourceCategorylist})
    }
    handleTableChange = (page) => {
        this.handleSearch(null, {
            pageNumber: page.current,
            pageSize: page.pageSize,
        });
    };
    // 获取资源列表
    handleSearch = (e?, pagination = {}, fileType?) => {
        e && e.preventDefault();
        let fields = this.props.form.getFieldsValue();
        let {category, title} = fields
        let categoryId = null
        if (category) {
            categoryId = category[category.length - 1]
        }
        let queryParams = new QueryResourceParams({
            categoryId,
            title,
            resourceType: fileType || this.props.fileType,
            maxSize: this.props.maxSize,
            ...pagination
        })
        this.queryResource(queryParams)
    }
    queryResource = async(params: QueryResourceParams) => {
        try {
            this.setState({loading: true})
            let page = await this.uploadService.queryResource(params, this.props.resourceUrl)
            this.setState({loading: false})
            this.setState({page})
        }
        catch {
            this.setState({loading: false})
        }
    }
    handleReset = () => {
        this.props.form.resetFields();
        this.handleSearch();
    }
    // 行类
    getRowClass = (record: ResourceItem) => {
        let hasClass = this.state.selectedResource.some(item => item.resourceId === record.resourceId)
        return hasClass ? 'selectFromStoreModal_selected_row' : ''
    }
    clickRow = async (record: ResourceItem) => {
        // if (this.props.fileType === 'VIDEO' || this.props.fileType === 'AUDIO') {
        //         await this.setState({selectedResource: [record]})
        // } else {
        //     if (this.state.selectedResource.some(item => item.resourceId === record.resourceId)) {
        //         await this.setState({selectedResource: this.state.selectedResource.filter(item => item.resourceId !== record.resourceId)})
        //     } else {
        //         await this.setState({selectedResource: [...this.state.selectedResource, record]})
        //     }
        // }
        await this.setState({selectedResource: [record]})
        this.props.selectFile(this.state.selectedResource)
    }
    componentDidMount () {
        this.getResourceCategoryList()
        this.handleSearch();
    }
    componentWillReceiveProps (nextProps) {
        if (nextProps && nextProps.fileType && (nextProps.fileType !== this.props.fileType) && nextProps.visible) {
            this.handleSearch(null, {}, nextProps.fileType);
        }
    }
    render() {
        let { getFieldDecorator } = this.props.form;
        let {visible, onCancel, fileType} = this.props
        let {page, videoAudioColumns, documentColumns,
            resourceCategorylist, loading, selectedResource} = this.state
        return (
            <Modal
                width="952px"
                title={`从资源库中选择`}
                className="selectFromStoreModal"
                maskClosable = {false}
                footer = {null}
                onCancel={onCancel}
                visible={visible}>
                    <div className="selectFromStoreModal_form filter_container">
                        <Form className="remarks" {...this.formItemLayout} colon={false}>
                            <Row gutter={[48, 10]}>
                                <Col span={8}>
                                    <Form.Item label="资源分类：">
                                        {getFieldDecorator("category", {
                                            initialValue: [],
                                            })(<MultipleLevelCascader options={resourceCategorylist} />)}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="名称：">
                                        {getFieldDecorator("title", {
                                            initialValue: '',
                                            })(<Input name="title" maxLength={50} />)}
                                    </Form.Item>
                                </Col>
                                <Col span={8} className="tr">
                                    <Form.Item label=" ">
                                        <Button type="primary" htmlType="submit" icon="search" onClick={this.handleSearch}>
                                            查询
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    <div className="selectFromStoreModal_list">
                        <Table
                            // rowClassName={this.getRowClass}
                            onRow={record => {
                                return {
                                  onClick: this.clickRow.bind(null, record) // 点击行
                                };
                            }}
                            rowKey="resourceId"
                            pagination={{
                                showSizeChanger: true,
                                showQuickJumper: true,
                                showTotal: () => `共 ${page.totalElements} 条`,
                                pageSizeOptions: ['5','10', '20', '50', '100'],
                                current: page.pageNumber,
                                pageSize: page.pageSize,
                                size: "large",
                                total: page.totalElements,
                            }}
                            size="middle"
                            dataSource={page.content}
                            columns={fileType === 'DOCUMENT' ? documentColumns: videoAudioColumns}
                            onChange={this.handleTableChange}
                            loading={loading}
                            />
                    </div>
            </Modal>
        )
    }
}
const mapPropsToFields = props => {
    return {
        onCancel: Form.createFormField({
            ...props.onCancel,
            value: props.onCancel
        }),
        visible: Form.createFormField({
            ...props.visible,
            value: props.visible
        })
    };
};
export default Form.create({mapPropsToFields})(SelectFromStoreModal);
